import Loader from '@anm/components/Loader';
import styled from 'styled-components';

export const LoaderWrapper = styled(Loader)`
  margin-bottom: 80px;
`;
